import Action from 'automation-ui-action-features/records/Action';
import { getEdgeId } from 'automation-ui-canvas/components/canvas/copyPaste/insertAndUpdateFlowWithLocallyStoredAction';
import { getAllEndMarkersData } from 'automation-ui-canvas/utils/endMarkerFlowUtils';
import { translateToGraph } from 'automation-ui-canvas/utils/platformWorkflowTranslators';
export const formatAiGeneratedActions = generatedActions => {
  return Object.values(generatedActions).map(action => new Action(action));
};
export const hatchActionEggs = ({
  flowId,
  portalId,
  actionEggs
}) => {
  return Object.values(actionEggs).map(action => new Action(Object.assign({}, action, {
    flowId,
    portalId
  })));
};
export const appendActionsToEdge = ({
  flow,
  startingActionId,
  edgeId,
  actionsToAppend
}) => {
  let nextAvailableActionId = flow.nextAvailableActionId;
  let updatedActions = flow.actions;
  actionsToAppend.forEach(action => {
    const {
      actionId
    } = action;
    updatedActions = updatedActions.set(actionId, action);
    nextAvailableActionId = Math.max(nextAvailableActionId, actionId);
  });
  let updatedFlow = flow.setActions(updatedActions);
  updatedFlow = updatedFlow.insertAction({
    action: updatedFlow.getActionById(startingActionId),
    actionId: startingActionId,
    edgeId,
    insertDownstreamActions: true
  }).set('nextAvailableActionId', nextAvailableActionId + 1);

  // due to multiple connected actions being able to  be generated we will need to reconnect the orphaned action
  const maybeOrphanedAction = flow.getActionByParentEdgeId(edgeId);
  if (maybeOrphanedAction) {
    const lastAppendedAction = actionsToAppend[actionsToAppend.length - 1];
    const targetEdgeId = `${lastAppendedAction.getActionId()}-edge-1`;
    updatedFlow = updatedFlow.insertAction({
      action: maybeOrphanedAction,
      actionId: maybeOrphanedAction.getActionId(),
      edgeId: targetEdgeId,
      insertDownstreamActions: true
    });
  }
  return updatedFlow;
};
export const appendActionsToFlow = ({
  flow,
  startingActionId,
  actionsToAppend
}) => {
  let edgeId = 'enrollment-edge-0';
  const hasExistingActions = flow.getActionsAsList().length;
  if (hasExistingActions) {
    // get all endmarkers to setup finding the first endmarker
    const flowAsGraph = translateToGraph(flow, false);
    const endMarkerNodes = getAllEndMarkersData({
      flow,
      directedGraph: flowAsGraph
    });
    const firstEndMarkerId = endMarkerNodes.keys().next().value;
    edgeId = getEdgeId('AFTER', flow, firstEndMarkerId);
  }
  return appendActionsToEdge({
    flow,
    startingActionId,
    edgeId,
    actionsToAppend
  });
};
export function transformFlowWithAppendedActions({
  firstActionId,
  actions,
  edgeId,
  originalFlow
}) {
  return !edgeId ? appendActionsToFlow({
    actionsToAppend: actions,
    startingActionId: firstActionId,
    flow: originalFlow
  }) : appendActionsToEdge({
    actionsToAppend: actions,
    startingActionId: firstActionId,
    edgeId,
    flow: originalFlow
  });
}